<template>
    <wrapper>
        <main class="main-content-wrapper">
            <card>
                <div class="row">
                    <div class="col-lg-4">
                        ID
                        <input
                            type="text"
                            class="form-control"
                            placeholder="Contoh: DSP-080825-001"
                            v-model="searchDisposalId"
                        />
                    </div>
                    <div class="col-lg-4">
                        Tanggal
                        <input
                            type="date"
                            class="form-control"
                            v-model="searchDisposalDate"
                        />
                    </div>
                    <div class="col-lg-4">
                        Pembuat Disposal
                        <input
                            type="text"
                            class="form-control"
                            placeholder="Contoh: Rangga Kusuma"
                            v-model="searchCreatedBy"
                        />
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-lg-4">
                        Transaksi ID ERP
                        <input
                            type="text"
                            class="form-control"
                            placeholder="Contoh: MAT-STE-2026-01534"
                            v-model="searchErpTrxId"
                        />
                    </div>
                    <div class="col-lg-4">
                        Transaksi ID Jurnal
                        <input
                            type="text"
                            class="form-control"
                            placeholder="Contoh: 2098743"
                            v-model="searchJurnalTrxId"
                        />
                    </div>
                    <div class="col-lg-4">
                        Status
                        <select class="form-control" v-model="searchDisposalStatus">
                            <option
                                v-for="opt in disposalStatusOptions"
                                :key="opt.status"
                                :value="opt.status"
                            >{{ opt.statusName }}</option>
                        </select>
                    </div>
                </div>
                <div class="d-flex justify-content-end mt-4">
                    <button
                        class="btn btn-primary default-btn"
                        :disabled="loadingSearchButton"
                        @click="searchData(1)"
                    >
                        <span v-if="loadingSearchButton">
                            <img src="~@/assets/images/2.gif" style="height: 18px; margin-right: 4px;" />
                        </span>
                        Cari
                    </button>
                    <button class="btn reset-btn default-btn ml-2" @click="resetSearch()">
                        Reset
                    </button>
                </div>
            </card>

            <div class="mt-4 d-flex align-items-center">
                <button class="btn btn-primary" @click="toCreateDisposal()" v-if="allowCreateDisposal">
                    + Disposal Baru
                </button>
            </div>
            <div class="disposal-table-wrapper mt-3">
                <table class="table disposal-table">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>TANGGAL</th>
                            <th>DIBUAT OLEH</th>
                            <th>CHANNEL</th>
                            <th>TRANSAKSI ID ERP</th>
                            <th>TRANSAKSI ID JURNAL</th>
                            <th>STATUS</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="loadingTable === false && totalData == '0'">
                            <td colspan="7" class="text-center">Data Not Available</td>
                        </tr>
                        <tr v-else-if="loadingTable === true">
                            <td colspan="7" class="text-center">
                                <img src="~@/assets/images/load-button.gif" />
                            </td>
                        </tr>
                        <tr v-for="(data, index) in disposalList" v-else :key="`disposal-${data.id}`">
                            <td class="text-center">
                                <router-link :to="{ path: '/disposal/' + data.id, query: { code: data.disposalCode } }">
                                    {{ data.disposalCode }}
                                </router-link>
                            </td>
                            <td>{{ data.createdAt }}</td>
                            <td>{{ data.createdByName }}</td>
                            <td>{{ data.channel }}</td>
                            <td>{{ data.transaksiIdErp || '-' }}</td>
                            <td>
                                <template v-if="data.transaksiIdJurnal">
                                    <div v-for="(jurnalId, jIndex) in splitJurnalIds(data.transaksiIdJurnal)" :key="`jurnal-${index}-${jIndex}`">
                                        {{ jurnalId }}
                                    </div>
                                </template>
                                <template v-else>-</template>
                            </td>
                            <td class="text-center">
                                <span :class="statusBadgeClass(data.statusDisposal)">{{ data.statusDisposal }}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="d-flex justify-content-between align-items-center mt-3">
                <div class="d-flex align-items-center">
                    <select
                        class="form-control form-control-sm showing-select"
                        v-model="itemPerPage"
                        @change="searchData(1)"
                    >
                        <option value="10">Showing data 10</option>
                        <option value="20">Showing data 20</option>
                        <option value="50">Showing data 50</option>
                    </select>
                    <span class="total-data ml-3">Total Data {{ totalData }}</span>
                </div>
                <div class="d-flex align-items-center">
                    <button
                        class="btn btn-sm pagination-arrow-btn"
                        @click="searchData(parseInt(currentPage) - 1)"
                        :disabled="currentPage <= 1"
                    >&lt;</button>
                    <button class="btn btn-sm btn-primary pagination-page-btn mx-2">
                        Page {{ currentPage }} of {{ totalPage || 1 }}
                    </button>
                    <button
                        class="btn btn-sm pagination-arrow-btn"
                        @click="searchData(parseInt(currentPage) + 1)"
                        :disabled="currentPage >= totalPage"
                    >&gt;</button>
                </div>
            </div>
        </main>
    </wrapper>
</template>

<script>
import swal from 'sweetalert';
import { Wrapper, Card } from '../Layout';

export default {
    name: 'DisposalListPage',
    components: {
        Wrapper,
        Card,
    },
    data() {
        return {
            spaceRegex: /[ ﻿ ]/g,
            allowCreateDisposal:false,
            allowUpdateDisposal: false,
            allowDeleteDisposal:false,
            loadingSearchButton: false,
            loadingTable: true,
            searchDisposalId: '',
            searchDisposalDate: '',
            searchCreatedBy: '',
            searchErpTrxId: '',
            searchJurnalTrxId: '',
            searchDisposalStatus: '',
            disposalStatusOptions: [
                { status: '', statusName: 'All' },
                { status: 'Pending', statusName: 'Pending' },
                { status: 'Partial', statusName: 'Partial' },
                { status: 'Done', statusName: 'Done' },
                { status: 'Failed', statusName: 'Failed' },
            ],
            disposalList: [],
            totalData: '0',
            totalPage: 1,
            currentPage: 1,
            itemPerPage: '10',
        };
    },
    methods: {
        cekPermission() {
            this.permission = localStorage.getItem('roles').replace(/"/g, "").replace("[", "").replace("]", "").split(",") 
            if(!this.permission.includes('26.1')) {
                this.$router.push('/');
            }
            if(this.permission.includes('26.2')) {
                this.allowUpdateDisposal = true
            }
            if(this.permission.includes('26.3')) {
                this.allowCreateDisposal = true
            }
            if(this.permission.includes('26.4')) {
                this.allowDeleteDisposal = true
            }
        },
        splitJurnalIds(value) {
            return String(value).split(',').map((id) => id.trim()).filter(Boolean);
        },
        statusBadgeClass(status) {
            const map = {
                pending: 'disposal-badge disposal-badge-pending',
                partial: 'disposal-badge disposal-badge-partial',
                done: 'disposal-badge disposal-badge-done',
                failed: 'disposal-badge disposal-badge-failed',
            };
            return map[(status || '').toLowerCase()] || 'disposal-badge disposal-badge-pending';
        },
    searchData(page) {
            this.$router.push({
                path: '/disposal',
                query: { 
                    disposalId: this.searchDisposalId,
                    disposalDate: this.searchDisposalDate,
                    createdBy: this.searchCreatedBy,
                    erpTrxId: this.searchErpTrxId,
                    jurnalTrxId: this.searchJurnalTrxId,
                    status: this.searchDisposalStatus || '',
                    page: page,
                    itemPerPage: this.itemPerPage,
                },
            });
    },
        resetSearch() {
            this.searchDisposalId = '';
            this.searchDisposalDate = '';
            this.searchCreatedBy = '';
            this.searchErpTrxId = '';
            this.searchJurnalTrxId = '';
            this.searchDisposalStatus = '';
            this.itemPerPage = '10';
            this.searchData(1);
        },
        toCreateDisposal() {
            this.$router.push('/disposal/create');
        },
        getData() {
            this.loadingTable = true;
            this.searchDisposalId = this.$route.query.disposalId || '';
            this.searchDisposalDate = this.$route.query.disposalDate || '';
            this.searchCreatedBy = this.$route.query.createdBy || '';
            this.searchErpTrxId = this.$route.query.erpTrxId || '';
            this.searchJurnalTrxId = this.$route.query.jurnalTrxId || '';
            this.searchDisposalStatus = this.$route.query.status || '';
            this.currentPage = parseInt(this.$route.query.page) || 1;
            this.itemPerPage = this.$route.query.itemPerPage || '10';

            this.$http
                .post(
                    process.env.SEARCH_DISPOSAL,
                    {
                        id: this.searchDisposalId || null,
                        dateCreated: this.searchDisposalDate || null,
                        createdBy: this.searchCreatedBy || null,
                        idErp: this.searchErpTrxId || null,
                        idJurnal: this.searchJurnalTrxId || null,
                        status: this.searchDisposalStatus.toLowerCase(),
                        page: this.currentPage,
                        itemPerPage: parseInt(this.itemPerPage),
                    },
                    {
                        headers: { 'Asani-Token': localStorage.getItem('jwt') },
                    }
                )
                .then((response) => {
                    if (response.data.status === 400) {
                        swal('Sorry', response.data.message, 'error', { button: 'Ok' });
                    } else if (response.data.status === 200) {
                        const content = response.data.data;
                        
                        this.disposalList = content.data;
                        this.totalPage = content.totalPage;
                        this.currentPage = content.currentPage;
                        this.totalData = content.totalData;
                        this.loadingTable = false;

                        // if (this.currentPage > content.totalPage) {
                        //     this.searchData(1);
                        //     return;
                        // }

                    }
                    
                })
                .catch((error) => {
                    this.loadingTable = false;
                    swal('Sorry', error.response.data.message, 'error', { button: 'Ok' }).then(() => {
                        if (error.response.data.status === 401) {
                            this.handleLogout();
                        }
                    });
                });
        },
        async handleLogout() {
            try {
                await this.$http.post(process.env.LOGOUT, {}, {
                    headers: { 'Asani-Token': localStorage.getItem('jwt') },
                });
            } catch (error) {
                if (error.response.data.status !== 401) return;
            }
            localStorage.removeItem('jwt');
            localStorage.removeItem('admin_name');
            localStorage.removeItem('roles');
            localStorage.removeItem('user_email');
            localStorage.removeItem('admin_id');
            this.$router.push('/');
        },
        cekLogin() {
            if (localStorage.getItem('jwt') == null) {
                this.$router.push('/');
            }
        },
    },
    watch: {
        $route() {
            this.getData();
        },
    },
    created() {
        this.cekLogin();
        this.getData();
        this.cekPermission()
    },
};
</script>

<style scoped>
.main-content-wrapper {
    padding: 24px;
}

.disposal-table-wrapper {
    background: #fff;
    border: 1px solid #e9ecef;
    border-radius: 12px;
    overflow: hidden;
}

.disposal-table {
    margin-bottom: 0;
}

.disposal-table thead th {
    text-align: center;
    font-size: 12px;
    font-weight: 700;
    color: #495057;
    text-transform: uppercase;
    letter-spacing: 0.02em;
    background-color: #f8f9fa;
    border-top: none;
    border-bottom: 1.5px solid #e9ecef;
    border-right: 1.5px solid #e9ecef;
    padding: 14px 16px;
    white-space: nowrap;
}

.disposal-table thead th:last-child {
    border-right: none;
}

.disposal-table tbody td {
    vertical-align: middle;
    font-size: 13px;
    color: #343a40;
    padding: 14px 16px;
    border-top: none;
    border-bottom: 1.5px solid #f1f3f5;
    border-right: 1.5px solid #f1f3f5;
}

.disposal-table tbody td:last-child {
    border-right: none;
}

.disposal-table tbody tr:last-child td {
    border-bottom: none;
}

.disposal-badge {
    display: inline-block;
    padding: 4px 14px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 600;
    border: 1px solid transparent;
}

.disposal-badge-pending {
    color: #6c757d;
    background: #eef1f4;
    border-color: #dfe4e8;
}

.disposal-badge-partial {
    color: #c98a06;
    background: #fff6e0;
    border-color: #f5e2ad;
}

.disposal-badge-done {
    color: #28a745;
    background: #e8f8ee;
    border-color: #c3ecd2;
}

.disposal-badge-failed {
    color: #dc3545;
    background: #fdecea;
    border-color: #f6c6c8;
}

.showing-select {
    width: auto;
    min-width: 140px;
}

.total-data {
    font-size: 14px;
    color: #343a40;
    white-space: nowrap;
}

.pagination-arrow-btn {
    border: 1px solid #dee2e6;
    background: #fff;
    color: #343a40;
    min-width: 32px;
}

.pagination-arrow-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.pagination-page-btn {
    min-width: 110px;
}

.default-btn {
    min-width: 80px;
}

.reset-btn {
    border: 1px solid #dee2e6;
    background: #fff;
    color: #343a40;
}

.reset-btn:hover {
    background-color: #f8f9fa;
}
</style>



// WEBPACK FOOTER //
// src/components/Disposal/DisposalListPage.vue